import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import { DateTool} from "mgToolsKit";
import RaisedButton from 'material-ui/RaisedButton';
import { ProgressBar } from "../../../Common/ui";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetBadgeComponent';

var styles = AppSettings.styles;

class WidgetBadge extends React.Component {
    constructor(props) {
        super(props);
       
        this.goToPage = this.goToPage.bind(this);
    }

    goToPage(){
              
        if(this.props.data.PageLink != "" && this.props.data.PageLink!=null){           
            //location.href = this.props.data.PageLink;
            window.open(this.props.data.PageLink,"Dettagli Badge");
        };  
        
    }   

    renderProgressBar(){

        var badge = this.props.data;        
        var percent=0;
        var total = badge.CurrentScore + badge.RemaningScore;
        if(total>0)
         percent = (badge.CurrentScore/total) * 100;
        if(badge.Score>0)
            percent = 100;
        if (percent>0){
            var _percent = (percent >= 100) ? 100 : Math.trunc(percent);
            return (
                <ProgressBar percentage={_percent} />
            );
        }else
            return ("");
    }
    
    render() {       

        var badge = this.props.data;
        var missionType= badge.mType;
        var livello= badge.Level;
        var nome = badge.Name;
        var score= badge.Score;
        var currentScore = badge.CurrentScore;
        var remaningScore = badge.RemaningScore;
        var description = badge.Description;
        var pageLink = badge.PageLink!=null && badge.PageLink!=""?decodeURI(badge.PageLink): "";       
        var cssClass = "mg-bonus-badge";
        var Image ="";
        if(badge.Image!=null)
            Image="data:image/png;base64,"+Buffer.from(badge.Image).toString('base64');

        if(score == 0 )
            if (currentScore>0)
                cssClass += " badge-running";
            else
                cssClass += " badge-blocked";
        else 
            cssClass += " badge-getted";
                
        
        return (
            <div className={cssClass}>                
                <div className="mg-dati-badge" onClick={this.goToPage}>
                    <div className="mg-badge-wrap">
                        <img className="mg-img-badge" src={Image}/>
                        <span className="mg-badge-livello">{ livello > 0 ?  "Livello ":""}{livello > 0 ?  <strong>{livello}</strong>:""}</span>
                        <span className="mg-badge-points">{ score > 0 ?  "Punti ":""}{score > 0 ?  <strong>{score}</strong>:""}</span>
                    </div>                      
                        <div className="mg-bonus-wrap">
                             {pageLink!=""?
                                <a className="mg-play-badge" href={pageLink} target="_blank">
                                    <span className="mg-user-widget-titolo">
                                    {nome}
                                    </span>
                                </a>
                                :
                                <span className="mg-user-widget-titolo">
                                    {nome}
                                    </span>
                            }
                            <div className="mg-user-widget-descr">
                                {description}
                            </div>
                            {(score == 0) ? 
                                <span className="mg-bonus-data">
                                    {this.renderProgressBar()}
                                </span>
                            : ""}
                        </div>
                    
                </div>
                {score==0 && currentScore>0 && missionType!=0?
                <div className="mg-status-badge">                   
                    <p>sei a <strong>{currentScore} punti</strong>, guadagna altri <strong>{remaningScore} punti</strong> per completare il livello!</p>                    
                </div>  
                :
                ""    
                }
                {missionType==0 && remaningScore>0?
                <div className="mg-status-badge">                   
                    <p>Guadagna altri <strong>{remaningScore} punti</strong> per sbloccare il prossimo livello!</p>                    
                </div>  
                :
                ""    
                }              
            </div>
        );
    }
}

WidgetBadge.displayName = componentName;

// PropTypes validation
WidgetBadge.propTypes = {
    data: PropTypes.object.isRequired
    

};

// default props
WidgetBadge.defaultProps = {
};

export default WidgetBadge;